import React, {Component} from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import {Helmet} from "react-helmet";

import './style.scss';
import {openPopup, sendOtp} from "../../general/Modal/action";
import {MODALS} from '../../general/Modal/constants';
import SecondaryNav from '../../general/SecondaryNav';
import {getInformationDetailContent, clearInformationDetail, verifyDistributor} from './actions';
import NoContent from '../../general/NoContent';
import Accordian from "../../general/Accordian/index";
import {formDataGenerator, getLang} from "../../../../utils/common";
import Input from "../../general/Input";
import Checkbox from "../../general/Checkbox";
import {Link} from "react-router-dom";
import {getCsrfToken, registerDistributor} from "../WhatsappJourney/action";

class InformationDetail extends Component {
  constructor(props) {
    super(props);
    this.state = {
      infoNodeId: '',
      pan: '',
      mobile: '',
      otp: '',
      checked: false,
      errors: '',
      seconds: 0,
      enableResendBtn: false,
      enableSend: true,
      arnData: true,
      isOtpSent:false
    }
    this.errors={}
  }

  componentDidMount = () => {
    const {getCsrfToken} = this.props;
    this.loadHandler();
    getCsrfToken();
    window.scrollTo(0,0);
  };
  // eslint-disable-next-line react/sort-comp
  componentWillUnmount() {
    this.props.clearInformationDetail();
  }
  componentWillReceiveProps(nextProps) {
    const {getInformationDetailContent, informationDetail, history: {
        location
      }} = this.props;
    let nodeId = nextProps.location.pathname.split('/');
    if (this.state.infoNodeId != "" && this.state.infoNodeId != nodeId[nodeId.length - 1]) {
      getInformationDetailContent({}, nodeId[nodeId.length - 1]);
      this.setState({
        infoNodeId: nodeId[nodeId.length - 1]
      })
    }
  }

  loadHandler = async () => {
    const {getInformationDetailContent, location: {
        pathname
      }} = this.props;
    let nodeId = pathname.split('/');
    // if(Object.keys(this.props.informationDetail).length==0 ){
    await getInformationDetailContent({}, nodeId[nodeId.length - 1]);
    this.setState({
      infoNodeId: nodeId[nodeId.length - 1]
    })

    const {openPopup, informationDetail} = this.props;

    if (informationDetail && document.getElementsByClassName('openModal').length > 0) {
      document.getElementsByClassName('openModal')[0].onclick = (event) => {
        event.preventDefault();
        openPopup(MODALS.ACCOUNT_STATEMENT, {
          modalClass: 'account-statement',
          heading: 'Account Statement'
        })
      }
    }
    // }

  };
  onChange = (name, value)  => {
    let {register} = this.props;

    if(register && register.statusCode !== 1 && register.statusCode !== 4 && (name == 'otp' || name == 'mobile')){
      register.message='';
    }

    if(register && register.statusCode == 4 && name == 'mobile'){
      register.message='';
    }

    if(name === 'terms') {
      this.setState((prevState) => {
        return {
          checked: !prevState.checked
        }
      });
    }
    if (name === 'pan') {
      this.setState({
          errors: {
              ...this.state.errors,
              pan: ""
          }
      })
  }
  if (name === 'mobile') {
      this.setState({
          errors: {
              ...this.state.errors,
              mobile: ""
          }
      })
  }
    this.setState({
      [name]: value,
    })
    if(name === 'pan' && name === 'mobile'){
      this.setState({
        arnData: true
      })
    }
  }

  onBlur = (name, value) => {
    switch (name) {
      case 'pan':
        value.length > 2 || !value
            ? delete this.errors[name]
            : this.errors.pan = 'ARN is not correct';
        break;
      case 'mobile':
        value.length === 10 || !value
            ? delete this.errors[name]
            : this.errors.mobile = 'Mobile no. is not correct';
        break;
      default:
        this.errors[name] ? delete this.errors[name] : false;

    }
    this.setState({
      errors: this.errors,
    })
  }
  register = async() => {
    const {registerWhatsapp, token} = this.props,
        {pan, mobile, otp} = this.state;
    let data = {
      pan,
      mobileNumber: mobile,
      otpCode: otp,
      type: 'whatsapp_service',
    }
    await registerWhatsapp(formDataGenerator(data), token);

    let {register, openPopup} = this.props;
    const modalData = {
      title: 'Thank you',
      description: register.message,
    };
    if (register.statusCode === 1 || register.statusCode === 4) {
      clearInterval(this.timer);
      this.setState({
        pan: '',
        mobile: '',
        otp: '',
        checked: false,
        errors: '',
        arnData: true,
        enableResendBtn: false,
        enableSend: true,
      })
      openPopup(MODALS.ALERT, modalData);
    }
    if (register.statusCode !== 2) {
      this.setState({
        seconds: 0,
      })
    }
  }

  resendOtp = async () => {
    this.setState({
      isOtpSent:true,
    })
    const { mobile, pan } = this.state,
        { verifyDistributor } = this.props;
    let params = {
      pan,
      type: 'whatsapp_service',
      mobileNumber: mobile,
    }
    let status = await verifyDistributor(formDataGenerator(params));
    if (status && status.data.arnData && !status.data.arnExists) {
      this.timer = setInterval(() => {
        if (this.state.seconds > 0) {
          this.setState(prevState => ({
            enableSend: false,
            enableResendBtn: false,
            seconds: prevState.seconds - 1
          }));
        } else {
          clearInterval(this.timer);
          this.setState({ enableSend: false, enableResendBtn: true });
        }
      }, 1000);
    }
    status && status.data.arnData && !status.data.arnExists ?
        this.setState({ seconds: 30, enableSend: false, arnExists: status.data.arnExists }) :
        this.setState({ arnData : status.data.arnData, enableSend: true, arnExists: status.data.arnExists })
  };
  render() {
    const {getInformationContent, informationDetail} = this.props;
    const {infoNodeId} = this.state;
    let { pan, mobile, otp, checked, errors, enableResendBtn, seconds, enableSend, arnData, arnExists } = this.state,
        {banner, faqs, meta, register, location: { pathname }} = this.props;

    let show_form = pathname.includes('mf-whatsapp-service-distributors');
    return ( informationDetail && informationDetail.title === 'Key Know-How' ?  <div className="wrapper">
      <Helmet>
        <title>{informationDetail && informationDetail.title}</title>
        <meta name="description" content={informationDetail && informationDetail.meta && informationDetail.meta.description}/>
        <meta property="og:title" content={informationDetail && informationDetail.meta && informationDetail.meta.title}/>
        <meta property="og:description" content={informationDetail && informationDetail.meta && informationDetail.meta.description}/>
      </Helmet>
        <section className="aboutHead">
          <div className="container">
            <div className="d-flex">
              <h1 className="me-auto">
                <span>Key</span> Know-How
              </h1>

              <nav aria-label="breadcrumb" className="align-self-center breadCrumbCust d-md-inlin">
                <ol className="breadcrumb mb-0">
                  <li className="breadcrumb-item"><a href="/">Home</a></li>
                  <li className="breadcrumb-item active breadcolor" aria-current="page">{ informationDetail && informationDetail.title ?  informationDetail.title : ''  }</li>
                </ol>
              </nav>
            </div>
          </div> 
        </section>
            {informationDetail && informationDetail.body ? <div dangerouslySetInnerHTML={{__html: informationDetail.body }}  />  : null} 
    </div>
    
    :
     informationDetail && <div className="information">
      {
        informationDetail && informationDetail.meta && <Helmet>
            <title>{informationDetail.meta.title}</title>
            <meta name="description" content={informationDetail.meta.description}/>
            <meta name="keywords" content={informationDetail.meta.keywords}/>
            <meta property="og:title" content={informationDetail.meta.og_title}/>
            <meta property="og:description" content={informationDetail.meta.description}/>
          </Helmet>
      }
      <SecondaryNav {...this.props} className='new-website'/>
      <div className="scheme-banner">
        <h2 className="container-930">{informationDetail.title}</h2>
      </div>
      {
        informationDetail.head != null
            ? <div className="product-content container" dangerouslySetInnerHTML={{
              __html: informationDetail.head
            }} />
            : show_form && <NoContent />
      }
      {show_form && <div className='form-fields'>
        <div className='field'>
          <span>ARN*</span>
          <Input
              name='pan'
              placeHolder='Enter ARN'
              onChange={this.onChange}
              value={pan}
              maxLength={7}
              isNumeric
              blurChange={this.onBlur}
              // errorMessage={!arnData ? 'ARN is not registered. Please try again.' : errors.pan}
              errorMessage={errors.pan}
          />
        </div>
        <div className='field'>
          <span>Mobile*</span>
          <Input
              name='mobile'
              placeHolder='Enter Mobile Number'
              onChange={this.onChange}
              value={mobile}
              isNumeric
              maxLength={10}
              // errorMessage={register && register.statusCode === 4 && register.message || errors.mobile}
              errorMessage={errors.mobile}
              blurChange={this.onBlur}
              inline
          />
        </div>
        <div className='field'>
          <span>OTP*</span>
          <Input
              name='otp'
              placeHolder='Enter your OTP'
              onChange={this.onChange}
              value={otp}
              isNumeric
              errorMessage={register && register.statusCode !== 1 && register.statusCode !== 4 && register.message}
              maxLength={6}
              disabled={!arnData}
              disableField={!(mobile.length === 10) || (mobile.length === 10 && !this.state.isOtpSent)}
          />
        </div>
        {(enableSend && !arnData && !arnExists) && <span className='common-error'>Either ARN or Mobile Number is incorrect. Please try again.</span>}
        {(enableSend && arnData && arnExists) && <span className='common-error'>Either ARN or Mobile Number is already registered. Please try again.</span>}
        <div className='resend-container'>
          {<button className='btn-primary'
                   disabled={!(mobile.length === 10 && pan.length > 2 && seconds === 0)}
                   onClick={this.resendOtp}>
            {enableSend && !enableResendBtn ? 'Send OTP' : 'Resend OTP'}
          </button>}
          {seconds !== 0 && <span>OTP has been sent. If you haven't received yet,<br /> please wait {seconds} for resend</span>}
        </div>
        <Checkbox checked={checked} onClick={() => this.onChange('terms', checked)}/>
        <span className='terms-link'>
                        <Link to='/information/terms-and-conditions-transaction-bot-and-whatsapp'>
                            I have read WhatsApp Service Terms and Conditions
                        </Link>
                    </span>
        <button className='btn-primary'
                disabled={!((mobile.length === 10) && (otp.length === 6) && (pan.length > 2) && checked)}
                onClick={this.register}>Register
        </button>
      </div>}

      {
        informationDetail.body != null
          ? <div className="product-content container" dangerouslySetInnerHTML={{
                __html: informationDetail.body
              }} />
          : <NoContent />
      }

    </div>)
  }
}
const mapStateToProps = (state) => (
  {
    commonContent: state.commonContent,
    informationDetail: state.informationDetail,
    token: state.whatsAppService.token,
    register: state.whatsAppService.registerDisStatus,
  });

const mapDispatchToProps = (dispatch) => ({
  getInformationDetailContent: bindActionCreators(getInformationDetailContent, dispatch),
  openPopup: bindActionCreators(openPopup, dispatch),
  clearInformationDetail: bindActionCreators(clearInformationDetail, dispatch),
  sendOtp: bindActionCreators(sendOtp,dispatch),
  registerWhatsapp: bindActionCreators(registerDistributor,dispatch),
  getCsrfToken: bindActionCreators(getCsrfToken, dispatch),
  verifyDistributor: bindActionCreators(verifyDistributor, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(InformationDetail);
